import { Component, ElementRef, ErrorHandler, Input, OnInit, ViewChild } from "@angular/core";
import { BBResponseContainer } from "../carrier/response-container";
import { SelectableLab } from "../carrier/selectable-lab";
import { MasterDataService } from "../masterdata/masterdata.service";
import { MasterList } from "../masterdata/masterList-enum";
import { LabMDM } from "../masterdata/models/lab";
import { ParentageAnalysis } from "../masterdata/models/parentage";
import { MessagesService } from "../messages/messages.service";
import * as cloneDeep from 'lodash/cloneDeep';
import { SubTypes } from "../masterdata/models/subTypes";

@Component({
  selector: 'app-parentage-analysis',
  templateUrl: './parentage-analysis.component.html',
  styleUrls: ['./parentage-analysis.component.css']
})
export class ParentageAnalysisComponent implements OnInit {
  @Input() masterLists: Array<ParentageAnalysis>;

  @Input() tableCols: Array<ParentageAnalysis>;

  @Input() masterListType: MasterList;

  @Input() title: string;

  @Input() checkSelectedLab: SelectableLab;


  errorHandler: ErrorHandler = new ErrorHandler();

  selectedLab: SelectableLab;

  parentageAnalysis: ParentageAnalysis;

  selectedMasterList: ParentageAnalysis;

  masterList: any;

  _labOptions: Array<LabMDM>;

  subType: SubTypes;

  selectedLabId: string;

  selectedMotherOnlyConfMatch: string;

  selectedParentageSystemName: string;

  labOption: LabMDM[] = [];

  showParentageAnalysisDialoguge: boolean;

  selectableLab: SelectableLab;

  myFiles: string[] = [];

  blocked: boolean;

  markerListPopUP: boolean = false;

  strMarker = [];

  //motherOnly:ParentageAnalysis;
  selectedValue: ParentageAnalysis


  @ViewChild('resultFile')
  fileUploadElement: ElementRef;


  @Input() set labOptions(input: LabMDM[]) {
    this._labOptions = input.filter((lab: LabMDM) => lab.name === this.checkSelectedLab.lab.name);
  }
  isFileNotSelected : boolean = true;
  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
    this.showErrorOnSave = this.showErrorOnSave.bind(this);
    this.showErrorOnUpdate = this.showErrorOnUpdate.bind(this);
  }
  ngOnInit(): void {
    this.parentageAnalysis = { active: false };
    this.masterLists = [];
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectableLab.lab._id;
  }

  handleRowSelect(event: any) {
    const { data } = event;
    const { lab = {} } = data;
    const { _id = '' } = lab;
    this.parentageAnalysis = cloneDeep(data);
    this.parentageAnalysis.lab = this._labOptions.find((labOption: LabMDM) => labOption._id === _id);
    this.selectedParentageSystemName = this.parentageAnalysis.parentageSystemName;
    this.showParentageAnalysisDialoguge = true;
  }

  handleAddNewParentageAnalysis() {
    this.parentageAnalysis = { active: false };
    this.parentageAnalysis.subType = [
      { field: 'motherOnly', header: 'Mother Only', confMatch: '', conMisMatch: '', inExploitableData: '' },
      { field: 'fatherOnly', header: 'Father Only', confMatch: '', conMisMatch: '', inExploitableData: '' },
      { field: 'motherMatchFather', header: 'Mother match - Father', confMatch: '', conMisMatch: '', inExploitableData: '' },
      { field: 'motherNOMatch', header: 'Mother noMatch - Father', confMatch: '', conMisMatch: '', inExploitableData: '' },
      { field: 'motherInExploit', header: 'Mother inexploit - Father', confMatch: '', conMisMatch: '', inExploitableData: '' }

    ]
    this.showParentageAnalysisDialoguge = true;
  }
  file: any;
  onResultFileChange(event) {
    this.file = event.target.files[0];
    let fileName: string = this.file.name;
    if(!fileName.endsWith('.txt')){
      this.isFileNotSelected = true;
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Unsupported file format',
        detail: 'Only txt files are currently supported'
      })
    }else{
      this.isFileNotSelected = false;
    }
  }
  uploadStrMarkerResultFile() {
    let emptyArray = [];
    const reader = new FileReader();
      reader.onload = () => {
        let text = reader.result.toString();
      emptyArray.push(text);
      emptyArray.forEach(element => {
        this.parentageAnalysis.markersList = element.split(";");
      })
      if (this.parentageAnalysis.markersList != undefined && this.parentageAnalysis.markersList != null) {
        this._messageService.addSuccessMessage({
          severity: 'success', summary: 'File succesfully uploaded',
          detail: 'Markers List file uploaded Succesfully'
        });
      }
      else {
        this._messageService.addErrorMessage({
          severity: 'error', summary: 'File not uploaded',
          detail: 'Please upload MarkerList file'
        });
      }
    }
    reader.readAsText(this.file);
    this.fileUploadElement.nativeElement.value = "";
    this.isFileNotSelected = true;
  }
  isSaveDisabledParentageAnalysis() {
    if (this.parentageAnalysis == undefined && this.parentageAnalysis == null) {
      return true
    }
    if (!this.parentageAnalysis.parentageSystemName || this.parentageAnalysis.parentageSystemName.trim() == "" || !this.parentageAnalysis.lab) {
      return true;
    }
  }
  handleSaveOrUpdate() {
    const { _id } = this.parentageAnalysis;

    if (_id) {
      this._masterDataService.updateParentageAnalysis(JSON.stringify(this.parentageAnalysis), this.selectedLabId, _id).subscribe((response) => {
        this.showParentageAnalysisDialoguge = false;
        const selectedParentageAnalysisIndex: number = this.masterLists.findIndex((parentageAnalysisData: ParentageAnalysis) => parentageAnalysisData._id === _id);
        this.masterLists[selectedParentageAnalysisIndex] = response;
      }, this.showErrorOnUpdate);
    } else {
      this._masterDataService.createParentageAnalysis(JSON.stringify(this.parentageAnalysis), this.selectedLabId, "parentageAnalysis").subscribe((response: BBResponseContainer) => {
        const { data } = response;
        this.masterLists.push(data);
        this.showParentageAnalysisDialoguge = false;
      }, this.showErrorOnSave);
    }
  }


  showErrorOnSave() {
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: 'Failed to create Parentage Analysis. Try with other Status name, may be it is duplicate'
    });
  }

  showErrorOnUpdate() {
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: 'Failed to update Parentage Analysis. Try with other status name, may be it is duplicate'
    });
  }
  markerListPopUp() {
    this.markerListPopUP = true;
    this.strMarker =[];
    this.parentageAnalysis.markersList.forEach(markerName => {
      this.strMarker.push({ markerName: markerName });
    });
  }

  closeParentageAnalysis(){
    this.showParentageAnalysisDialoguge = false;
    this.fileUploadElement.nativeElement.value = "";
    this.isFileNotSelected = true;
  }
}
